import React from "react";

const Footer = () => {
  return (
    <div>
      {/* <main className=""> */}
      <footer
        className="footer pt-4 pb-3 mx-4"
        // style={{ position: "fixed", bottom: "0", width: "80%" }}
      >
        <div className="container-fluid">
          <div className="row align-items-center justify-content-lg-between">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="copyright text-center text-sm text-muted text-lg-start">
                ©  Registration4u.in
              </div>
            </div>
            <div className="col-lg-6">
             <div>
              <a>
                <p className="text-end">Designed & Developed by FIT</p>
              </a>
             </div>
            </div>
          </div>
        </div>
      </footer>
      {/* </main> */}
    </div>
  );
};

export default Footer;
